import { UrlConstants } from "../url.constants";
export class ApiModuleSettingConstants {
    static URL = UrlConstants.API_V2 + "ModuleSetting";
}
